import React, { useMemo, useRef, useState } from 'react';
import dayjs from 'dayjs';
import Datepicker from '../../../../Components/Ui/Datepicker';
import ZoomableImage from '../../../../Components/Ui/ZoomableImage';

const MAX_PHOTOS = 5;

export default function M_RNM_DAI_03(props) {
  const fileInputRef = useRef(null);

  const [resultContent, setResultContent] = useState('');
  const [resultDate, setResultDate] = useState(dayjs().format('YYYY-MM-DD'));

  const workInfoUpload = props.workInfoUpload;

  const previewList = useMemo(() => {
    return (workInfoUpload?.previewList ?? []).filter((i) => !i.deleted);
  }, [workInfoUpload?.previewList]);

  const photoCount = previewList.length;

  return (
    <div className="mx-auto flex min-h-full w-full max-w-md flex-col bg-[#f8fafc]">
      <main className="min-h-0 flex-1 space-y-6 overflow-y-auto p-4">
        {/* Action Results Section */}
        <section className="space-y-3">
          <div className="flex items-center gap-2 px-1">
            <span className="material-symbols-outlined text-xl text-[#3b82f6]">
              edit_note
            </span>
            <h2 className="text-base font-bold text-slate-900">조치 결과</h2>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <textarea
              className="min-h-[160px] w-full resize-none border-none bg-transparent p-0 text-slate-700 placeholder:text-slate-400 focus:ring-0"
              placeholder="조치 내용을 상세히 입력해주세요 (예: 소화기 교체 완료, 바닥 미끄럼 방지 테이프 부착 등)"
              value={resultContent}
              onChange={(e) => setResultContent(e.target.value)}
            />
          </div>
        </section>

        {/* Action Date Section */}
        <section className="space-y-3">
          <div className="flex items-center gap-2 px-1">
            <span className="material-symbols-outlined text-xl text-[#3b82f6]">
              calendar_today
            </span>
            <h2 className="text-base font-bold text-slate-900">조치일</h2>
          </div>

          <Datepicker
            value={resultDate}
            onChange={setResultDate}
            placeholder="날짜 선택"
            format="yyyy-mm-dd"
            inputClassName="flex items-center justify-between rounded-2xl border border-slate-200 bg-white p-4 shadow-sm focus:border-[#3b82f6] focus:ring-2 focus:ring-[#3b82f6]/50"
            iconClassName="text-slate-400 group-focus-within:text-[#3b82f6]"
          />
        </section>

        {/* After Improvement Photo Section */}
        <section className="space-y-3">
          <div className="flex items-center justify-between px-1">
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined text-xl text-[#10b981]">
                photo_camera
              </span>
              <h2 className="text-base font-bold text-slate-900">
                개선 후 사진
              </h2>
            </div>
            <span className="text-sm font-medium text-slate-400">
              {photoCount} / {MAX_PHOTOS}
            </span>
          </div>

          <div className="grid grid-cols-3 gap-3">
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              multiple
              className="hidden"
              onChange={(e) => workInfoUpload?.FileChange?.(e)}
            />

            <button
              type="button"
              onClick={() =>
                photoCount < MAX_PHOTOS && fileInputRef.current?.click()
              }
              disabled={photoCount >= MAX_PHOTOS}
              className="group flex aspect-square flex-col items-center justify-center rounded-2xl border-2 border-dashed border-slate-200 bg-white transition-colors hover:border-[#3b82f6] disabled:cursor-not-allowed disabled:opacity-50"
            >
              <span className="material-symbols-outlined mb-1 text-slate-400 group-hover:text-[#3b82f6]">
                add_a_photo
              </span>
              <span className="text-[10px] font-medium text-slate-400 group-hover:text-[#3b82f6]">
                사진 첨부
              </span>
            </button>

            {previewList.map((item, index) => (
              <div
                key={`${item.preview ?? index}_${index}`}
                className="relative aspect-square overflow-hidden rounded-2xl border border-slate-200 bg-slate-100"
              >
                <ZoomableImage
                  src={item.preview}
                  alt=""
                  className="h-full w-full object-cover"
                />
                <button
                  type="button"
                  onClick={() => workInfoUpload?.DeletePreview?.(item)}
                  className="absolute top-1 right-1 flex h-7 w-7 items-center justify-center rounded-full bg-black/50 text-white"
                  aria-label="사진 삭제"
                >
                  <span className="material-symbols-outlined text-sm">
                    close
                  </span>
                </button>
              </div>
            ))}
          </div>

          <p className="px-1 text-xs text-slate-500 italic">
            * 개선 사항이 잘 보이도록 근거리와 원거리 사진을 포함해 주세요.
          </p>
        </section>
      </main>

      {/* Footer Action Button */}
      <footer className="shrink-0 border-t border-slate-200 bg-white p-4">
        <div className="mx-auto max-w-md">
          <button
            type="button"
            onClick={() =>
              props.Save1({
                ...props.detailItem,
                gubun: props.detailItem.gubun === '위험요인 제보' ? '1' : '2',
                resultContent,
                resultDate,
              })
            }
            disabled={!resultContent.trim() && photoCount === 0}
            className="flex w-full items-center justify-center gap-2 rounded-2xl bg-[#3b82f6] py-4 font-bold text-white shadow-lg shadow-[rgba(59,130,246,0.2)] transition-all hover:bg-blue-600 active:scale-[0.98] disabled:opacity-60"
          >
            <span>조치 완료</span>
            <span className="material-symbols-outlined text-[20px]">
              check_circle
            </span>
          </button>
        </div>
      </footer>
    </div>
  );
}
